import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { DadosLoginService } from '@auth/services/dados-login.service';
import { PortalService } from '@auth/services/portal.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '@shared/alert/alert.service';
import { Subscription } from 'rxjs';
import { SideMenu } from 'src/app/models';
import { ApiGraficosService } from 'src/app/portal-coordenador/services/api-graficos.service';
import { ApiProjetoService } from 'src/app/portal-coordenador/services/api-projeto.service';
import { links } from '../links';
import { SeletorProjetosService } from './seletor-projetos.service';

@Component({
    selector: 'sume-seletor-projetos',
    templateUrl: './seletor-projetos.component.html',
    styleUrls: ['./seletor-projetos.component.scss'],
})
export class SeletorProjetosComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    @ViewChild('projectSelector') projectSelector;
    projetos;
    current_project;
    mostrarSeletor = false;

    portalSub: Subscription = null;

    _links: SideMenu[];

    constructor(
        private router: Router,
        private alertService: AlertService,
        private apiGraficos: ApiGraficosService,
        private apiProjeto: ApiProjetoService,
        private dadosLoginService: DadosLoginService,
        private modalService: NgbModal,
        private portalService: PortalService,
        private seletorProjetosService: SeletorProjetosService
    ) {
        this._links = this.seletorProjetosService.filtraLinksDesabilitados(
            links.coordenador
        );
    }

    ngOnInit(): void {
        this.dadosLoginService.dadosLogin$.subscribe({
            next: dadosLogin => {
                // Na nova interface, os projetos do coordenador estão em 'coordenador'
                this.projetos = dadosLogin.coordenador;
            },
            error: err => {
                console.error('Erro ao carregar dados de login:', err);
                this.alertService.error(err);
            },
        });
    }

    ngAfterViewInit() {
        this.portalSub = this.portalService.portalAtual$.subscribe(portal => {
            this.mostrarSeletor = portal === 'coordenador';
            if (this.mostrarSeletor) this.openProjectSelector();
        });
    }

    ngOnDestroy(): void {
        if (this.portalSub) this.portalSub.unsubscribe();
    }

    cancelProjectSelection(modal) {
        modal.dismiss('Cross click');
        this.router.navigateByUrl('/colaborador');
    }

    selectProject(projeto, modal) {
        this.apiProjeto.getProjeto(projeto.id_projeto).subscribe(res => {
            this.apiProjeto.setCurrent(res);
            this.updateFilter(res['titulo_curto']);
            const returnUrl =
                this.router.routerState.snapshot.root.queryParams[
                    'returnUrl'
                ] || '/coordenador';
            this.router.navigateByUrl(returnUrl);
            this.seletorProjetosService.setProjeto(res);
        });
        this.apiGraficos.changeProject(projeto.id_projeto);
        this.current_project = projeto;
        this.apiProjeto.setCurrent(projeto);
        modal.close('Cross click');
    }

    updateFilter(titulocurto: string) {
        const menu_autorizar = this.getMenuAutorizar();
        menu_autorizar.query = {
            ...menu_autorizar.query,
            titulo_curto: titulocurto,
        };
    }

    getMenuAutorizar() {
        const menu_requisicoes = this._links.find(el => el.id == 'requisicoes');
        return menu_requisicoes.submenus.find(
            sub => sub.id == 'requisicoes-autorizar'
        );
    }

    openScrollableContent(longContent) {
        this.modalService.open(longContent, {
            scrollable: true,
            backdrop: 'static',
        });
    }

    openProjectSelector() {
        const href = this.router.url;
        if (href.split('/').length > 2 && href.includes('coordenador')) {
            this.router.navigate(['coordenador/'], {
                queryParams: { returnUrl: href },
            });
        }
        this.openScrollableContent(this.projectSelector);
    }
}
